import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { IDistributionList, ILookup, IProjectList } from 'src/app/shared/models/app.model';
import { ProviderBase } from 'src/app/shared/services/provider.base';

@Injectable({
  providedIn: 'root',
})
export class ProjectListService extends ProviderBase {
  constructor(injector: Injector) {
    super(injector, 'api/');
  }

  getProjectList(): Observable<IProjectList> {
    return this.get<IProjectList>(`ProjectList.json`);
  }

  getLookup(): Observable<ILookup> {
    return this.get<ILookup>(`Lookup.json`);
  }

  getDistributionList(): Observable<IDistributionList> {
    return this.get<IDistributionList>(`DistributionList.json`);
  }
}
